import React from "react";

export function ShiftBridgeAssist({ title = "ShiftBridge Assist", steps = [], note = "" }) {
  return (
    <div
      style={{
        background: "#eff6ff",
        border: "1px solid #bfdbfe",
        borderRadius: 14,
        padding: "14px 16px",
        marginBottom: 16,
        color: "#1e3a8a",
      }}
    >
      <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 8 }}>
        {title}
      </div>

      <div style={{ fontWeight: 800, marginBottom: 6 }}>
        What to do next:
      </div>

      <ol style={{ margin: 0, paddingLeft: 20, fontSize: 13, lineHeight: 1.6 }}>
        {steps.map((step, index) => (
          <li key={index}>{step}</li>
        ))}
      </ol>

      {note ? (
        <div style={{ marginTop: 10, fontSize: 12, fontWeight: 700 }}>
          {note}
        </div>
      ) : null}
    </div>
  );
}

export function showAssistAlert(message) {
  window.alert(message);
}